import initialState from "./initial.value";

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Page_refresh": {
      let temp = JSON.parse(JSON.stringify(state.pageRefresh || {}));
      temp[action.payload] = (temp[action.payload] || 0) + 1;
      return { ...state, pageRefresh: JSON.parse(JSON.stringify(temp)) };
    }
    case "Product_list":
      return { ...state, product_list: action.payload };
    case "Dashbaord_RecentProduct":
      return { ...state, dashboard_recentproduct: action.payload };
    case "Dashbaord_ExpiredProduct":
      return { ...state, dashboard_expiredproduct: action.payload };
    case "Salesdashbaord_ExpiredProduct":
      return { ...state, saleshdashboard_recenttransaction: action.payload };
    case "Brand_list":
      return { ...state, brand_list: action.payload };

    case "Unit_Data":
      return { ...state, unit_data: action.payload };
    case "Variantattribute_Data":
      return { ...state, variantattributes_data: action.payload };
    case "Warranty_Data":
      return { ...state, warranty_data: action.payload };
    case "Barcode_Data":
      return { ...state, barcode_data: action.payload };
    case "Department_Data":
      return { ...state, departmentlist_data: action.payload };
    case "Designation_Data":
      return { ...state, designation_data: action.payload };
    case "Shiftlist_Data":
      return { ...state, shiftlist_data: action.payload };
    case "Attendenceemployee_Data":
      return { ...state, attendenceemployee_data: action.payload };
    case "toggle_header":
      return { ...state, toggle_header: action.payload };
    case "Invoicereport_Data":
      return { ...state, invoicereport_data: action.payload };
    case "Salesreturns_Data":
      return { ...state, salesreturns_data: action.payload };
    case "Quatation_Data":
      return { ...state, quotationlist_data: action.payload };
    case "customer_data":
      return { ...state, customerdata: action.payload };
    case "Userlist_data":
      return { ...state, userlist_data: action.payload };
    case "Rolesandpermission_data":
      return { ...state, rolesandpermission_data: action.payload };
    case "Deleteaccount_data":
      return { ...state, deleteaccount_data: action.payload };
    case "Attendenceadmin_data":
      return { ...state, attendanceadmin_data: action.payload };
    case "Leavesadmin_data":
      return { ...state, leavesadmin_data: action.payload };
    case "Leavestype_data":
      return { ...state, leavetypes_data: action.payload };
    case "Holiday_data":
      return { ...state, holiday_data: action.payload };
    case "Expiredproduct_data":
      return { ...state, expiredproduct_data: action.payload };
    case "Lowstock_data":
      return { ...state, lowstock_data: action.payload };
    case "Categotylist_data":
      return { ...state, categotylist_data: action.payload };
    case "Layoutstyle_data":
      return { ...state, layoutstyledata: action.payload };
    case "SET_SELECTED_PERIOD":
      console.log(
        "Reducer SET_SELECTED_PERIOD action.payload",
        action.payload.defaultSelectedPeriod
      );
      return {
        ...state,
        selected_period: action.payload.defaultSelectedPeriod,
      };
    case "SET_COMPARE_PERIOD":
      return { ...state, compare_period: action.payload.defaultComparePeriod };

    case "SET_FULL_NAME":
      localStorage.setItem("fullName", action.payload.fullName);
      localStorage.setItem("email", action.payload.email);
      return { ...state, fullName: action.payload.fullName, email: action.payload.email };
    case "SET_PERMISSIONS":
      // localStorage.setItem('permissions', JSON.stringify(action.payload));
      return { ...state, permissions: action.payload };
    case "SET_ROLE_TITLE":
      localStorage.setItem("roleTitle", action.payload);
      return { ...state, roleTitle: action.payload };
    case "SET_ROLE_TITLE_ADMIN":
      localStorage.setItem("roleTitleAdmin", action.payload);
      return { ...state, roleTitleAdmin: action.payload };

    case "SET_ACCESS_TOKEN":
      localStorage.setItem("accessToken", action.payload.accessToken);
      localStorage.setItem("access_token", action.payload.accessToken);
      localStorage.setItem("tanentId", action.payload.tenantId);
      localStorage.setItem("userId", action.payload.userId);
      return { ...state, accessToken: action.payload.accessToken };

    case "CLEAR_ACCESS_TOKEN":
      localStorage.removeItem("accessToken");
      localStorage.removeItem("access_token");
      localStorage.clear();
      return { ...state, accessToken: null };
    case "Store_list":
      return { ...state, store_list: action.payload };

    case "store_edit":
      console.log("action.payload:", action.payload); // Logs the payload
      return {
        ...state,
        store_edit: action.payload,
      };

    // Traget_Achivement_data
    case "Traget_Achivement_data":
      return { ...state, targets: action.payload };
    // layouts
    case "Set_layout_data":
      return { ...state, layoutGlobal: action.payload };
    //
    case "Add_model_dashboard":
      return { ...state, addModelDetail: action.payload };
    //
    case "SET_TRANSLATIONS":
      return { ...state, translations: action.payload };
    case "SET_CHANGE_LANG":
      // eslint-disable-next-line no-case-declarations
      const trans = state.translations[action.payload] || {};
      return { ...state, translation: trans };
    case "SET_TAB":
      return { ...state, subMenu: action.payload };
      
    default:
      return state;
  }
};

export default rootReducer;
